/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {IHarlequinGameData} from "./data/IHarlequinServerData";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";

export class HarlequinServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseDoReelNudge(rawData:IHarlequinGameData):boolean[] {
        return rawData.doReelNudge.concat();
    }

    public parseExtraSymbolsOnTop(rawData: IHarlequinGameData):string[][] {
        this.filterWildSymbols(rawData.extraSymbolsOnTop);

        return HarlequinServerDataParser.parseStackedSymbolsInReels(rawData.extraSymbolsOnTop);
    }

    // TODO: Fix extension typing HELL!
    /*public parseExtraSymbolsOnTopInit(rawData: IHarlequinServerData):string[][] {
        this.filterWildSymbols(rawData.extraSymbolsOnTop);

        return HarlequinServerDataParser.parseStackedSymbolsInReels(rawData.extraSymbolsOnTop);
    }*/

    private filterWildSymbols(reels:string[][]) {
        for(let i:number = 1; i < 4; i++) {
            reels[i].forEach((symName:string, index:number) => {
                if(symName === "W") {
                    reels[i][index] = `W${i}`;
                }
            });
        }
    }
}